import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { IconNail, IconShieldNail, IconPolish, IconHairStrands, IconLeaf, IconSparkle } from './ui/Icons';
const services = [{
  title: 'Esculturas de uñas',
  description: 'Extensiones perfectas y duraderas adaptadas a la forma natural de tus manos.',
  price: 'Desde $1.200',
  icon: IconNail
}, {
  title: 'Kapping',
  description: 'Capa protectora sobre tu uña natural para mayor resistencia y crecimiento.',
  price: 'Desde $900',
  icon: IconShieldNail
}, {
  title: 'Esmaltado Semi Permanente',
  description: 'Color impecable y brillo duradero por más de 15 días sin saltarse.',
  price: 'Desde $700',
  icon: IconPolish
}, {
  title: 'Laciados Orgánicos',
  description: 'Alisado sin formol que nutre, elimina el frizz y aporta un brillo espejo.',
  price: 'Desde $2.500',
  icon: IconHairStrands
}, {
  title: 'Cuidado Capilar',
  description: 'Tratamientos profundos para restaurar la salud y vitalidad de tu cabello.',
  price: 'Desde $1.500',
  icon: IconLeaf
}, {
  title: 'Tratamientos',
  description: 'Rituales de spa y nutrición intensiva para manos y cabello.',
  price: 'Consultar',
  icon: IconSparkle
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
export function Services() {
  return <section id="servicios" className="py-24 bg-brand-cream" data-id="element-180">
      <div className="container mx-auto px-6 md:px-12" data-id="element-181">
        <div className="text-center max-w-2xl mx-auto mb-16" data-id="element-182">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-serif text-brand-mocha mb-4" data-id="element-183">
            Nuestros Servicios
          </motion.h2>
          <motion.div initial={{
          opacity: 0,
          width: 0
        }} whileInView={{
          opacity: 1,
          width: '60px'
        }} viewport={{
          once: true
        }} className="h-[1px] bg-brand-gold mx-auto mb-6" data-id="element-184" />
          <motion.p initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-brand-mocha/70" data-id="element-185">
            Especialistas en el cuidado y belleza de tus manos y cabello,
            utilizando productos premium y técnicas de vanguardia.
          </motion.p>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-186">
          {services.map((service, index) => {
          const Icon = service.icon;
          return <motion.div key={index} variants={itemVariants} className="group bg-white p-8 rounded-2xl border border-brand-mocha/5 transition-all duration-300 hover:shadow-soft hover:-translate-y-1" data-id="element-187">
                <div className="w-12 h-12 rounded-full bg-brand-rose/10 flex items-center justify-center text-brand-rose mb-6 group-hover:bg-brand-rose group-hover:text-white transition-colors duration-300" data-id="element-188">
                  <Icon className="w-6 h-6" data-id="element-189" />
                </div>
                <h3 className="text-xl font-serif text-brand-mocha mb-3" data-id="element-190">
                  {service.title}
                </h3>
                <p className="text-brand-mocha/70 text-sm leading-relaxed mb-6 min-h-[60px]" data-id="element-191">
                  {service.description}
                </p>
                <div className="pt-4 border-t border-brand-mocha/5 flex items-center justify-between" data-id="element-192">
                  <span className="text-sm font-medium text-brand-mocha" data-id="element-193">
                    {service.price}
                  </span>
                  <a href="https://cfstudio.koob.uy" target="_blank" rel="noopener noreferrer" className="text-brand-rose text-sm font-medium hover:text-brand-mocha transition-colors" data-id="element-194">
                    Agendar →
                  </a>
                </div>
              </motion.div>;
        })}
        </motion.div>
      </div>
    </section>;
}